WL.registerComponent('on-title-click', {    
}, {    
    start: function() {
        this.target = this.object.getComponent('cursor-target');
        this.target.addDownFunction(() => {
            window.SW.gameState.state = State.gameplay;
        });
    }
});
